import { Box, withStyles } from '@material-ui/core';
import FsSubtitle from 'ui-elements/typography/FsSubtitle';

export const WrapperBox = withStyles(() => ({
  root: {
    width: '100%',
  },
}))(Box);

export const Title = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(2),
  },
}))(FsSubtitle);

export const BoxWithBorder = withStyles(
  ({ palette, spacing, breakpoints }) => ({
    root: {
      borderBottom: `1px solid ${palette.grey[200]}`,
      paddingBottom: spacing(3),
      [breakpoints.up('lg')]: {
        borderBottom: 0,
        paddingBottom: 0,
        marginBottom: 0,

        borderRight: `1px solid ${palette.grey[200]}`,
        paddingRight: spacing(3),
      },
    },
  })
)(Box);
